// Admin Page Actions

import { adminPageInitialState } from "./uiAdminPageState";

export const makeAdminPageActions = (set, get) => ({
  setActiveTab: (tab) =>
    set((s) => ({ adminPage: { ...s.adminPage, activeTab: tab } })),

  // Task management
  setCurrentTaskId: (taskId) =>
    set((s) => ({
      adminPage: {
        ...s.adminPage,
        currentTaskId: taskId,
        taskStatus: "pending",
        taskError: null,
      },
    })),
  setTaskStatus: (status) =>
    set((s) => ({ adminPage: { ...s.adminPage, taskStatus: status } })),
  setTaskError: (error) =>
    set((s) => ({
      adminPage: { ...s.adminPage, taskError: error, taskStatus: "failed" },
    })),
  clearTask: () =>
    set((s) => ({
      adminPage: {
        ...s.adminPage,
        currentTaskId: null,
        taskStatus: null,
        taskError: null,
      },
    })),

  resetAdminPage: () => set({ adminPage: adminPageInitialState }),
  setShowDatabaseUpdatesSection: (show) =>
    set((s) => ({
      adminPage: { ...s.adminPage, showDatabaseUpdatesSection: show },
    })),
  setShowEmployeeUpdatesSection: (show) =>
    set((s) => ({
      adminPage: { ...s.adminPage, showEmployeeUpdatesSection: show },
    })),
  setShowAdminUsersSection: (show) =>
    set((s) => ({
      adminPage: { ...s.adminPage, showAdminUsersSection: show },
    })),
  setShowProjectUnitsSection: (show) =>
    set((s) => ({
      adminPage: { ...s.adminPage, showProjectUnitsSection: show },
    })),
});
